import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import React from "react"

import { useTranslation } from "../../../i18n/translate"
import { DynamicPdfFile } from "../../dynamic-pdf-file/dynamic-pdf-file"
import InlineYoutubeVideo from "../../inline-youtube-video/inline-youtube-video"
import Tile from "../../tile/tile"
import TileContentSpacer from "../../tile/tile-content-spacer/tile-content-spacer"
import "./studies-and-training-downloads-grid.sass"

const StudiesAndTrainingDownloadsGrid = ({ downloads }) => {
  const { t } = useTranslation()

  return (
    <div className="_fp-studies-and-training-downloads-grid">
      {(downloads || [])
        .filter(
          (pdf) =>
            pdf.pdf_file &&
            pdf.pdf_file.pdf_file_items &&
            pdf.pdf_file.pdf_file_items.length > 0,
        )
        .map((pdf, i) => (
          <DynamicPdfFile
            customClass={"_fp-studies-and-training-downloads-grid__file"}
            pdf={pdf}
            key={`pdf-${i}`}
          />
        ))}
    </div>
  )
}

export default StudiesAndTrainingDownloadsGrid
